import ERetailer from './code/Scripts/components/eretailer/eretailer.vue';

export default {
  components: {
    ERetailer,
  },
};
